<template lang="html">
  <ext-form
    :formData="formData"
    :submitProxy="submitProxy"
    :loadProxy = "loadProxy"
    :extraData = "extraData"
  >
    <b-form-fieldset
      label="Сущность"
      :feedback = "errors.first('entity')"
      :class="{'is-invalid': errors.has('entity') }"
    >
      <input class="form-control" v-validate="'required'" v-model="formData.entity" name="entity"/>
    </b-form-fieldset>

    <b-form-checkbox v-model="formData.create" :value="1" :unchecked-value="0">
      Создание
    </b-form-checkbox>
    <b-form-checkbox v-model="formData.read" :value="1" :unchecked-value="0">
      Чтение
    </b-form-checkbox>
    <b-form-checkbox v-model="formData.update" :value="1" :unchecked-value="0">
      Обновление
    </b-form-checkbox>
    <b-form-checkbox v-model="formData.delete" :value="1" :unchecked-value="0">
      Удаление
    </b-form-checkbox>
    <b-form-checkbox v-model="formData.owner" :value="1" :unchecked-value="0">
      Изменение владельцем
    </b-form-checkbox>
    <br>
  </ext-form>
</template>

<script>
import ExtForm from '@/components/ExtForm'

export default {
  components: {
    ExtForm
  },
  props: ['loadProxy', 'submitProxy', 'extraData'],
  data () {
    return {
      formData: {
        entity: '',
        create: 0,
        read: 0,
        update: 0,
        delete: 0,
        owner: 0
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RightForm.vue?630123ee